export function CartUpdatesHandler() {
  function handle(data) {
    updateLineItems(data)
    updateOrderSummary(data)
    updateProductThumbnailControls(data)
    updateShoppingBagCounter(data)
    hideLoadingBar()
    notifyQuantityChange();
  }

  function notifyQuantityChange () {
    window.dispatchEvent(new CustomEvent("update-quantity"));
  }

  function updateShoppingBagCounter (data) {
    let cartBag = document.querySelector(".shopping-bag-item-count")
    cartBag.innerText = data.order.item_count
  }

  function updateProductThumbnailControls (data) {
    let productControlsWrappers = document.querySelectorAll(`[data-hook="product-controls-${data.product_id}"]`)

    if (productControlsWrappers.length > 0 && data.updated_product_controls) {
      productControlsWrappers.forEach(el => el.innerHTML = data.updated_product_controls)
    }
  }

  function updateOrderSummary (data) {
    let orderSummary = document.querySelector("[data-hook='order-summary']")
    orderSummary.innerHTML = data.order_summary
  }

  function updateLineItems (data) {
    let lineItemsContent = document.querySelector("[data-line-items-list]")
    lineItemsContent.innerHTML = data.line_items_content
  }

  function hideLoadingBar () {
    let progress = document.querySelector("#progress")
    progress.classList.remove("loading")
  }

  return {
    handle,
  }
}
